import { scrapersAPI } from '../api/scrapers';

export default function handleRunScraper(stateCode, callbacks = {}) {
  const stream = scrapersAPI.runStateScraperStream(stateCode, {
    cacheMode: 'off',
    verbose: false,
  });

  stream.addEventListener('progress', (event) => {
    const data = JSON.parse(event.data);
    callbacks.onProgress?.(data);
  });

  stream.addEventListener('complete', (event) => {
    const data = JSON.parse(event.data);
    callbacks.onComplete?.(data);
    stream.close();
  });

  stream.addEventListener('error', () => {
    callbacks.onError?.();
    stream.close();
  });

  return stream;
}
